import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { SEO } from '../components/SEO';

export const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/yg3mqisk_IMG_1100.jpeg',
      alt: 'Happy student celebrating driving test pass',
      caption: 'Another successful pass with Top Driver!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/e4wtyxx5_IMG_1118.jpeg',
      alt: 'Successful student with pass certificate',
      caption: 'Confident and ready to drive!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/89hz25ay_IMG_1116.jpeg',
      alt: 'Student passed driving test with Top Driver',
      caption: 'First time pass - well done!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/jatldrqv_IMG_1114.jpeg',
      alt: 'Another successful driving test pass',
      caption: 'Smiles all around after passing!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/w9cqwkiw_IMG_1111.jpeg',
      alt: 'Proud student with driving pass certificate',
      caption: 'Excellence in every lesson!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/9624hzkq_IMG_1123.jpeg',
      alt: 'Happy student passed with Top Driver',
      caption: 'Celebrating another first-time pass!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/y1ym48wb_IMG_1122.jpeg',
      alt: 'Successful student with Top Driver car',
      caption: 'Ready to hit the road!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/mpqscg38_IMG_1121.jpeg',
      alt: 'Another Top Driver success story',
      caption: 'Passed with confidence!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/g0qc8mpu_IMG_1119.jpeg',
      alt: 'Student celebrating pass with Top Driver',
      caption: 'Great result - congratulations!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/p6i7oj8c_IMG_1124.jpeg',
      alt: 'Top Driver student passed driving test',
      caption: 'Another happy customer!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/nptfo2tm_IMG_1102.jpeg',
      alt: 'Successful student with pass certificate and Top Driver car',
      caption: 'First time success!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/at85df7e_IMG_1103.jpeg',
      alt: 'Happy student celebrating test pass',
      caption: 'Well deserved pass!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/n1unv24c_IMG_1104.jpeg',
      alt: 'Student with pass certificate at Top Driver',
      caption: 'Brilliant achievement!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/jh4a5eb6_IMG_1105.jpeg',
      alt: 'Another happy student passed with Top Driver',
      caption: 'Driving dreams come true!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/9qbj3jwd_IMG_1106.jpeg',
      alt: 'Proud student with pass certificate',
      caption: 'Outstanding result!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/agkadgp0_IMG_1108.jpeg',
      alt: 'Happy male student celebrating test success',
      caption: 'Thrilled with the result!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/3ji4kswv_IMG_1109.jpeg',
      alt: 'Female student passed with Top Driver',
      caption: 'Fantastic achievement!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/pxch04kq_IMG_1110.jpeg',
      alt: 'Student with pass certificate and Top Driver car',
      caption: 'Success with a smile!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/s4d6157s_IMG_1112.jpeg',
      alt: 'Male student celebrating driving test pass',
      caption: 'Liverpool success story!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/iv5gv812_IMG_1113.jpeg',
      alt: 'Female student passed driving test',
      caption: 'Another Top Driver winner!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/zu2ww5ja_IMG_1101.jpeg',
      alt: 'Male student celebrating pass with Top Driver',
      caption: 'Fantastic first time pass!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/uvag7v9q_IMG_1104.jpeg',
      alt: 'Happy student with pass certificate and Top Driver car',
      caption: 'Well done on passing!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/16tzqbu6_IMG_1115.jpeg',
      alt: 'Female student passed with Top Driver Driving School',
      caption: 'Congratulations on your success!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/11rxjb90_IMG_1117.jpeg',
      alt: 'Student celebrating test pass with Top Driver',
      caption: 'Brilliant achievement!'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/7js940me_IMG_1120.jpeg',
      alt: 'Female student with pass certificate',
      caption: 'Another successful pass story!'
    }
  ];

  return (
    <div className="min-h-screen">
      <SEO 
        title="Success Stories Gallery - Liverpool Students"
        description="See our successful Liverpool students who passed their driving tests with Top Driver. Real students, real results. Join thousands of confident drivers across Liverpool and Merseyside."
        keywords="driving test success Liverpool, passed driving test Liverpool, student testimonials Liverpool, Liverpool driving school gallery"
        canonical="https://topdriver.co.uk/gallery"
      />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-5xl sm:text-6xl font-bold text-black mb-6">
              Success Stories Gallery
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Real students, real success. See the smiles of our confident graduates who passed their driving tests with Top Driver!
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="pb-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {galleryImages.map((item) => (
              <Card
                key={item.image}
                className="border-2 border-gray-200 hover:border-red-600 transition-all duration-300 overflow-hidden cursor-pointer group"
                onClick={() => setSelectedImage(item)}
              >
                <CardContent className="p-0">
                  <div className="aspect-square relative overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.alt}
                      className="w-full h-full object-cover object-[center_25%] group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-end">
                      <div className="w-full p-4 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <p className="text-white font-medium text-sm">
                          {item.caption}
                        </p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              Join our Community of successful Drivers
            </h2>
            <p className="text-lg text-gray-600">
              These are just a few of the 105+ students who've achieved their driving goals with us
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
            <div className="text-center">
              <p className="text-5xl font-bold text-red-600 mb-2">105+</p>
              <p className="text-gray-600 font-medium">Students Trained</p>
            </div>
            <div className="text-center">
              <p className="text-5xl font-bold text-black mb-2">60%</p>
              <p className="text-gray-600 font-medium">First-Time Pass Rate</p>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-red-600 transition-colors duration-200"
            onClick={() => setSelectedImage(null)}
          >
            <X className="w-8 h-8" />
          </button>
          <div className="max-w-5xl w-full">
            <img
              src={selectedImage.image}
              alt={selectedImage.alt}
              className="w-full h-auto rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
            <p className="text-white text-center mt-4 text-lg">
              {selectedImage.caption}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
